<div class="widget-title">CNV %</div>
<div class="conversionContainer">
    <div class="innerConversionContainer">
        <div [ngClass]="noData ? 'col-1': 'col-12'" class="canvasBox">
            <canvas  id="conversionCanvas">
            </canvas>
        </div>
        <div *ngIf="noData" class="noData">No Data Available</div>
    </div>
</div>
